var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DentalArchesSVG',{key:_vm.reRenderCounter,staticClass:"figure",attrs:{"id":_vm.mapID}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }